var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiMediaSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 9V5C3.6 4.2268 4.2268 3.6 5 3.6H9C9.7732 3.6 10.4 4.2268 10.4 5V9C10.4 9.7732 9.7732 10.4 9 10.4H5C4.2268 10.4 3.6 9.7732 3.6 9ZM3.6 19V15C3.6 14.2268 4.2268 13.6 5 13.6H9C9.7732 13.6 10.4 14.2268 10.4 15V19C10.4 19.7732 9.7732 20.4 9 20.4H5C4.2268 20.4 3.6 19.7732 3.6 19ZM13.6 9V5C13.6 4.2268 14.2268 3.6 15 3.6H19C19.7732 3.6 20.4 4.2268 20.4 5V9C20.4 9.7732 19.7732 10.4 19 10.4H15C14.2268 10.4 13.6 9.7732 13.6 9Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0873 20.351L17.3092 17.5729M17.3092 17.5729C17.5156 17.3666 17.6793 17.1216 17.791 16.852C17.9027 16.5824 17.9601 16.2934 17.9601 16.0016C17.9601 15.7097 17.9027 15.4207 17.791 15.1511C17.6793 14.8815 17.5156 14.6365 17.3092 14.4302C17.1029 14.2238 16.8579 14.0601 16.5883 13.9485C16.3187 13.8368 16.0297 13.7793 15.7379 13.7793C15.446 13.7793 15.1571 13.8368 14.8875 13.9485C14.6178 14.0601 14.3729 14.2238 14.1665 14.4302C13.7498 14.8469 13.5156 15.4122 13.5156 16.0016C13.5156 16.5909 13.7498 17.1562 14.1665 17.5729C14.5833 17.9897 15.1485 18.2238 15.7379 18.2238C16.3273 18.2238 16.8925 17.9897 17.3092 17.5729Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiMediaSearch);
export default __webpack_public_path__ + "static/media/multiMediaSearch.6cc295070858eb1d57f5728ce97c6345.svg";
export { ForwardRef as ReactComponent };